export default __webpack_public_path__ + "static/media/content-management-systems.abc08226.png";